import api from '@/utils/api';

/**
 * 会员相关接口
 */

/**
 * 获取会员套餐列表
 * @param {Object} params - 查询参数
 * @param {string} params.page - 页码
 * @param {string} params.limit - 每页数量
 * @returns {Promise}
 */
export function getMemberPackages(params) {
  return api.get('/member_card/packages', {
    params: {
      page: params.page || '1',
      limit: params.limit || '10'
    }
  });
}

/**
 * 获取会员购买记录
 * @param {Object} params - 查询参数
 * @param {string} params.payment_status - 支付状态: pending=待支付, paid=已支付, failed=支付失败
 * @returns {Promise}
 */
export function getMemberRecords(params) {
  return api.get('/member_card/records', {
    params: {
      payment_status: params.payment_status || ''
    }
  });
}

/**
 * 会员下单
 * @param {Object} params - 下单参数
 * @param {number} params.package_id - 套餐id
 * @param {string} params.payment_method - 支付方式，JSON格式如 {"wechat": 88.00, "balance": 12.00} 或字符串 'wechat'
 * @returns {Promise}
 */
export function createMemberOrder(params) {
  const formData = new FormData();
  formData.append('package_id', params.package_id);

  // 处理支付方式：如果是对象，转换为JSON字符串；如果是字符串，直接使用
  let paymentMethod = params.payment_method;
  if (typeof paymentMethod === 'object') {
    paymentMethod = JSON.stringify(paymentMethod);
  }
  formData.append('payment_method', paymentMethod);

  return api.post('/member_card/order', formData);
}

/**
 * 兑换码兑换
 * @param {Object} params - 兑换参数
 * @param {string} params.code - 兑换码
 * @returns {Promise}
 */
export function redeemMemberCode(params) {
  const formData = new FormData();
  formData.append('code', params.code || '');
  return api.post('/member_card/redeemCode', formData);
}
